// src/components/DashboardCards.jsx
import React, { useState } from "react";
import {
  Card,
  Typography,
  CardActionArea,
  Box,
  Collapse,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Person, LocalHospital, Bed, Assessment } from "@mui/icons-material";


import DoctorProfile from "./DoctorProfile/DoctorProfile";
import EditDoctor from "./DoctorProfile/editDoctorProfile";
import DoctorAvailability from "./DoctorAvailability/DoctorAvailability";
import AssignDoctor from "./AssignDoctor";
import DoctorPerformanceReport from "./DoctorPerformance/DoctorPerformanceReport";
import { decrypt } from "../../components/cryptoUtil";
import DashboardCards from "../HospitalDashBoardCards";
import { includeCardForRoles, ROLES } from "../componenet/heading";







const DoctorDashBoard = () => {
  const [activeIndex, setActiveIndex] = useState(null);
 const tokenData = localStorage.getItem("tokenData");
    const decryptedData = tokenData ? JSON.parse(decrypt(tokenData)) : {};
    const userName = decryptedData.userfullname || "";
    const userRole = decryptedData.userrole || "";

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));


const cardRoles = {
  "Add Doctor Profile": [ROLES.RECEPTIONIST], // only userRole 101 can see
  "Edit Doctor Profile": [ROLES.RECEPTIONIST],   // only userRole 102 can see
  "Manage Doctor Availability": [ROLES.RECEPTIONIST],
  "Assign Doctors Duty (Monthly)": [ROLES.STAFF],
  "Doctor Performance Report": [ROLES.ACCOUNTSECTION],
  
};



  const cards = [
    
     ...includeCardForRoles(cardRoles["Manage Doctor Profile"], userRole,{
      title: "Manage Doctor Profile",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🏥</span> : null,
      component: <DoctorProfile />,category: "👨‍⚕️ Doctor Data Managament",
    }),
    //  ...includeCardForRoles(cardRoles["Edit Doctor Profile"], userRole,{
    //   title: "Edit Doctor Profile",
    //   icon: !isMobile ? <span style={{ fontSize: "2rem" }}>🛌</span> : null,
    //   component: <EditDoctor />,category: "👨‍⚕️ Doctor Data Managament",
    // }),
     ...includeCardForRoles(cardRoles["Manage Doctor Availability"], userRole,{
      title: "Manage Doctor Availability",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>✔️</span> : null,
      component: <DoctorAvailability />,category: "👨‍⚕️ Doctor Data Managament",
    }),
     ...includeCardForRoles(cardRoles["Assign Doctors Duty (Monthly)"], userRole,{
      title: "Assign Doctors Duty (Monthly)",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <AssignDoctor />,category: "👨‍⚕️ Doctor Data Managament",
    }),
     ...includeCardForRoles(cardRoles["Doctor Performance Report"], userRole,{
      title: "Doctor Performance Report",
      icon: !isMobile ? <span style={{ fontSize: "2rem" }}>📊</span> : null,
      component: <DoctorPerformanceReport />,category: "👨‍⚕️ Doctor Data Managament",
    }),


  ];




  // const handleCardClick = (index) => {
  //   setActiveIndex(activeIndex === index ? null : index);
  // };





//
 
  
     return (
      <DashboardCards
        cards={cards}
        menulabel={1}
        welcomeMessage={
          <Typography variant="h5" align="center" gutterBottom>
           👨‍⚕️ Welcome {userName}
          </Typography>
        }
      />
    );
  };

export default DoctorDashBoard;
